import React, { FC, useState, useEffect } from 'react';
import { formatTime } from '@/utils';
import Requests from '@/services/request';
import $i18n from '../../../../../../i18n';
import { Drawer, Table, Message } from '@b-design/fusion';
import FlowDrawerHeader from '../flowDrawerHeader';
import { getQueryStringArgs } from '@/utils/url-parse';
import './index.less';

/**
 * 版本管理抽屉
 */
interface PropsType {
  visible: boolean;
  setVisible: (value: boolean) => void;
  record: any;
}

const ViewVersionDrawer: FC<PropsType> = ({ visible, setVisible, record }) => {
  const { spaceId } = getQueryStringArgs();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  /**
   * 下载
   */
  const downloadJson = async (downloadUrl, version) => {
    try {
      const response = await fetch(downloadUrl);
      if (response?.status !== 200) {
        Message.error(
          $i18n.get({ id: 'aopf.component.viewVersionDrawer.DownloadFailed', dm: '下载失败' }),
        );
        return;
      }
      const blob = await response.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `${record.identify}_V${version}.json`;
      a.click();
      a.remove();
    } catch (error) {
      Message.error(
        $i18n.get({ id: 'aopf.component.viewVersionDrawer.DownloadFailed', dm: '下载失败' }),
      );
      console.error(error);
    } finally {
    }
  };

  const downloadWorkflow = (_version) => {
    Requests.get('/rest/intercnn/aigc/workflow/download', {
      spaceId,
      identify: record.identify,
      version: _version,
    }).then((data) => {
      if (!data?.downloadUrl) {
        return;
      }
      downloadJson(data.downloadUrl, _version);
    });
  };

  const defaultColumns = [
    {
      title: $i18n.get({ id: 'aopf.component.viewVersionDrawer.VersionNumber', dm: '版本号' }),
      dataIndex: 'version',
      width: 140,
      cell: (value) => (value ? `V ${value}` : ''),
    },
    {
      title: $i18n.get({
        id: 'aopf.component.viewVersionDrawer.VersionDescription',
        dm: '版本描述',
      }),
      dataIndex: 'description',
    },
    {
      title: $i18n.get({ id: 'aopf.component.viewVersionDrawer.UpdateTime', dm: '更新时间' }),
      dataIndex: 'gmtModified',
      width: 160,
      cell: (value) => formatTime(value),
    },
  ];

  const columns =
    `${record?.isCustom}` === '1'
      ? [
          ...defaultColumns,
          {
            title: $i18n.get({ id: 'aopf.component.viewVersionDrawer.Operation', dm: '操作' }),
            dataIndex: 'action',
            width: 120,
            cell: (_v, _i, record) => (
              <a className="action" onClick={() => downloadWorkflow(record.version)}>
                <img src="https://gw.alicdn.com/imgextra/i4/O1CN01S14FHM1UXsGq5edtj_!!6000000002528-2-tps-42-42.png" />
                <span>
                  {$i18n.get({ id: 'aopf.component.viewVersionDrawer.Download', dm: '下载' })}
                </span>
              </a>
            ),
          },
        ]
      : defaultColumns;

  /**
   * 初始化表单数据请求
   */
  const initData = () => {
    setLoading(true);
    Requests.get('/rest/intercnn/aigc/workflow/version', { spaceId, identify: record.identify })
      .then((data) => {
        setTableData(data || []);
        setLoading(false);
      })
      .catch(() => {
        setTableData([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!visible) return;
    initData();
  }, [visible]);

  return (
    <Drawer
      visible={visible}
      title={$i18n.get({
        id: 'aopf.component.viewVersionDrawer.VersionManagement',
        dm: '版本管理',
      })}
      width={640}
      onClose={() => setVisible(false)}
      className="view-flow-common-drawer view-version-drawer"
    >
      <FlowDrawerHeader record={record} />
      <Table
        dataSource={tableData}
        columns={columns}
        hasBorder={false}
        loading={loading}
        primaryKey="version"
      />
    </Drawer>
  );
};

export default ViewVersionDrawer;
